import { useQuery, useSubscription } from '@apollo/client';
import { last } from 'ramda';
import { useEffect } from 'react';

import { useChatSession } from '~/modules';

import { INTAKE_UPDATE_CHAT_SESSION_CURRENT_STEP } from './IntakeCurrentStep.subscription.gql';
import { INTAKE_DETAIL_QUERY } from './IntakeDetailQuery.gql';

export const useIntakeDetail = () => {
  const session = useChatSession();

  const { data, refetch } = useQuery(INTAKE_DETAIL_QUERY, {
    variables: session,
    fetchPolicy: 'cache-and-network', // Allow cache updates while avoiding merge conflicts
  });
  const { data: subscribedData } = useSubscription(INTAKE_UPDATE_CHAT_SESSION_CURRENT_STEP, { variables: session });

  const currentStepSequence = subscribedData?.sevenbridges?.chatSession?.currentStep.sequence ?? -1;

  const chatMessages = data?.sevenbridges?.chatSession.chatMessages ?? [];
  const lastChatMessage = last(chatMessages ?? []);
  const lastChatMessageSequence = lastChatMessage?.sequence ?? -1;

  useEffect(() => {
    if (currentStepSequence > lastChatMessageSequence) {
      refetch();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStepSequence]);

  return {
    chatSession: data?.sevenbridges?.chatSession,
    chatMessages,
  };
};
